export const ID = '25ff1561-9dd4-4d94-a5be-0e1f3b3a819a';

export const NAME = 'YouTube / Vimeo';
